import { useState, useEffect } from 'react'

function RDMSBranding({ showFooter = true, variant = 'full' }) {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

  useEffect(() => {
    setCurrentYear(new Date().getFullYear())
  }, [])

  // Full footer with complete branding
  if (showFooter && variant === 'full') {
    return (
      <div style={footerStyle}>
        <div style={footerContentStyle}>
          {/* RDMS Logo and Name */}
          <div style={footerLogoSection}>
            <img 
              src="/rdms-logo.png" 
              alt="Raola Digital Marketing Services" 
              style={logoStyle} 
            />
            <div style={companyInfoStyle}>
              <span style={companyNameStyle}>Raola Digital Marketing Services</span>
              <span style={companyTagStyle}>Enterprise Digital Solutions</span>
            </div>
          </div>

          {/* Address - Updated to Jikwoyi, AMAC Abuja */}
          <div style={addressStyle}>
            <p>📍 <strong>Address:</strong> Jikwoyi, AMAC Abuja, Nigeria</p>
          </div>

          {/* Copyright */}
          <div style={copyrightStyle}>
            © {currentYear} Raola Digital Marketing Services (RDMS). All rights reserved.
          </div>
          <div style={taglineStyle}>
            <span style={productNameStyle}>🏢 EstatesFlow CRM</span> - A Product of RDMS
          </div>
        </div>
      </div>
    )
  }

  // Compact footer
  if (showFooter && variant === 'compact') {
    return (
      <div style={compactFooterStyle}>
        <div style={compactContentStyle}>
          <img src="/rdms-logo.png" alt="RDMS" style={compactLogoStyle} />
          <span style={compactTextStyle}>© {currentYear} Raola Digital Marketing Services</span>
          <span style={compactProductStyle}>EstatesFlow CRM</span>
        </div>
        <div style={compactAddressStyle}>
          📍 Jikwoyi, AMAC Abuja
        </div>
      </div>
    )
  }

  return null
}

// Styles
const footerStyle = {
  marginTop: '60px',
  paddingTop: '30px',
  borderTop: '1px solid #e2e8f0',
  background: '#f8fafc'
}

const footerContentStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 20px 30px 20px',
  textAlign: 'center'
}

const footerLogoSection = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '15px',
  marginBottom: '20px',
  flexWrap: 'wrap'
}

const logoStyle = {
  height: '50px',
  width: 'auto',
  objectFit: 'contain'
}

const companyInfoStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
}

const companyNameStyle = {
  fontSize: '18px',
  fontWeight: '700',
  color: '#1e3a5f'
}

const companyTagStyle = {
  fontSize: '11px',
  color: '#64748b',
  marginTop: '2px'
}

const addressStyle = {
  background: '#f0fdf4',
  padding: '8px 16px',
  borderRadius: '8px',
  marginBottom: '20px',
  fontSize: '12px',
  color: '#166534',
  display: 'inline-block'
}

const copyrightStyle = {
  fontSize: '12px',
  color: '#64748b',
  marginBottom: '8px'
}

const taglineStyle = {
  fontSize: '11px',
  color: '#94a3b8'
}

const productNameStyle = {
  fontWeight: '600',
  color: '#1e3a5f'
}

const compactFooterStyle = {
  marginTop: '40px',
  padding: '15px 20px',
  borderTop: '1px solid #e2e8f0',
  background: '#fff'
}

const compactContentStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '10px',
  fontSize: '11px',
  color: '#64748b'
}

const compactLogoStyle = {
  height: '25px',
  width: 'auto'
}

const compactTextStyle = {
  fontSize: '11px'
}

const compactProductStyle = {
  fontSize: '11px',
  fontWeight: '500',
  color: '#1e3a5f'
}

const compactAddressStyle = {
  fontSize: '10px',
  color: '#64748b',
  textAlign: 'center',
  marginTop: '8px',
  paddingTop: '8px',
  borderTop: '1px solid #e2e8f0'
}

export default RDMSBranding